(() => {
  const fetchDrawerSection = async () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sections', 'cart-drawer');
    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
    });
    if (!response.ok) throw new Error(`Cart drawer refresh failed: ${response.status}`);
    return response.json();
  };

  const bindFurmilyProductForm = () => {
    const form = document.getElementById('FurMilyProductForm');
    if (!form || form.dataset.fmAjaxCartBound === 'true') return;

    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;

    form.dataset.fmAjaxCartBound = 'true';

    form.addEventListener('submit', async (event) => {
      const submitButton = form.querySelector('button[name="add"][type="submit"]');
      if (!submitButton) return;

      event.preventDefault();
      if (submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') return;

      let errorNode = form.querySelector('[data-fm-atc-error]');
      if (!errorNode) {
        errorNode = document.createElement('p');
        errorNode.dataset.fmAtcError = '';
        errorNode.setAttribute('role', 'alert');
        errorNode.hidden = true;
        errorNode.style.cssText = 'margin:8px 0 0;color:#a23b2a;font-size:12px;font-weight:700;text-align:center;';
        submitButton.insertAdjacentElement('afterend', errorNode);
      }

      errorNode.hidden = true;
      errorNode.textContent = '';
      submitButton.disabled = true;
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.setAttribute('aria-busy', 'true');
      drawer.setActiveElement?.(submitButton);

      let addSucceeded = false;

      try {
        const formData = new FormData(form);
        const sections = drawer.getSectionsToRender?.().map((section) => section.id).filter(Boolean) || ['cart-drawer'];
        formData.set('sections', sections.join(','));
        formData.set('sections_url', window.location.pathname);

        const addUrl = window.routes?.cart_add_url || '/cart/add.js';
        const response = await fetch(addUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
          credentials: 'same-origin',
        });

        const text = await response.text();
        let data = {};
        try {
          data = text ? JSON.parse(text) : {};
        } catch {
          throw new Error(`Invalid add-to-cart response (${response.status})`);
        }

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Unable to add this item to the cart.');
        }

        addSucceeded = true;
        let rendered = false;

        if (data.sections?.['cart-drawer']) {
          rendered = drawer.renderContents(data) !== false;
        }

        if (!rendered) {
          try {
            const sectionsPayload = await fetchDrawerSection();
            rendered = drawer.renderContents({ id: data.id, sections: sectionsPayload }) !== false;
          } catch (refreshError) {
            console.warn('[FurMily drawer refresh]', refreshError);
          }
        }

        if (!rendered) {
          window.location.assign(window.routes?.cart_url || '/cart');
          return;
        }

        drawer.refreshHeaderCartCount?.();
      } catch (error) {
        console.error('[FurMily ATC]', error);
        if (addSucceeded) {
          window.location.assign(window.routes?.cart_url || '/cart');
          return;
        }
        errorNode.textContent = error?.message || 'Unable to add this item to the cart. Please try again.';
        errorNode.hidden = false;
      } finally {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-disabled');
        submitButton.removeAttribute('aria-busy');
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindFurmilyProductForm, { once: true });
  } else {
    bindFurmilyProductForm();
  }

  document.addEventListener('shopify:section:load', bindFurmilyProductForm);
})();
